import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {PraticaLight} from '../../../common/models/pratica/pratica-light';
import {CssClassMapping} from '../../../core/configuration/css-class-mapping';
import {MappingTipiEntitaFascicolo} from '../../../common/configuration/mapping-tipi-entita-fascicolo';
import {FascicoloLight} from '../../../common/models/fascicolo/fascicolo-light';
import { SimpleChanges } from '@angular/core';
import { RoutingConfigurationUtilService } from 'src/app/core/services/routing-configuration-util.service';

@Component({
  selector: 'app-suggested-practices',
  templateUrl: './suggested-practices.component.html',
  styleUrls: ['./suggested-practices.component.css']
})
export class SuggestedPracticesComponent implements OnInit, OnChanges {

  @Input() pratiche: PraticaLight[]
  @Input() buttonAssociaHide: boolean = false;
  @Output() createFascicoloEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() associaFascicoloEvent: EventEmitter<string> = new EventEmitter<string>();
  isShowFascicolo: boolean[] = [];

  constructor(private routingService: RoutingConfigurationUtilService) { }

  ngOnInit() {
    console.log(this.pratiche);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.pratiche && changes.pratiche.currentValue) {
      this.isShowFascicolo = [];
      for (let i = 0; i < this.pratiche.length; i++) {
        this.isShowFascicolo.push(true);
      }
    }
  }

  getClassPratica(idTipoPratica) {
    return CssClassMapping.cssTipiPratica[idTipoPratica];
  }

  hasFascicoloSanitario(pratica: PraticaLight) : boolean {
    return !!(pratica.fascicoliLight && pratica.fascicoliLight.find(element=>element.tipoFascicolo && element.tipoFascicolo.id === MappingTipiEntitaFascicolo.FASCICOLO_SINISTRO_SANITARIO));
  }

  getCssClassCategoriaFascicolo(fascicolo: FascicoloLight) {
    if(fascicolo.tipoFascicolo && fascicolo.tipoFascicolo.categoria){
      let categoriaMap = CssClassMapping.cssTipiCategoriaFascicolo[fascicolo.tipoFascicolo.categoria.id];
      return categoriaMap;
    }
  }

  createFascicolo(index: number) {
    this.createFascicoloEvent.emit({id: this.pratiche[index].id,
    tipoPratica: this.pratiche[index].tipoPratica.descrizione,
    codice: this.pratiche[index].codice });
  }

  associaFascicolo(praticaIndex: string, fascicoloIndex: string) {
    this.associaFascicoloEvent.emit(this.pratiche[praticaIndex].fascicoliLight[fascicoloIndex].id);
  }

  showFascicolo(indexPratica: number) {
    this.isShowFascicolo[indexPratica] = !this.isShowFascicolo[indexPratica];
  }

  getPraticaPath(idTipoPratica: string): string {
    return this.routingService.getRoutingVisualizzazionePraticaModule(idTipoPratica);
  }

  getFascicoloPath(pratica: PraticaLight, fascicolo: FascicoloLight): string {
    return this.routingService.checkStatoFascicoloAndGetRoutingPath( fascicolo,
      pratica.tipoPratica.id, fascicolo.tipoFascicolo.id);
  }

}
